<template>
  <v-col>
    <v-row>
      <v-col class="text-h6 mb-2">
        <slot name="title">Filter</slot>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" md="auto">
        <v-checkbox
          v-for="item in leftItems"
          :key="item.id"
          :model-value="modelValue"
          :value="item.id"
          class="mr-2"
          density="compact"
          hide-details
          @update:model-value="$emit('update:modelValue', $event)"
        >
          <template #label>
            <FacetCheckboxLabel
              :facet-counts="facetCounts"
              :facet-name="facetName"
              :value="item"
            />
          </template>
        </v-checkbox>
      </v-col>

      <v-col cols="12" md="auto">
        <v-checkbox
          v-for="item in rightItems"
          :key="item.id"
          :model-value="modelValue"
          :value="item.id"
          class="mr-2"
          density="compact"
          hide-details
          @update:model-value="$emit('update:modelValue', $event)"
        >
          <template #label>
            <FacetCheckboxLabel
              :facet-counts="facetCounts"
              :facet-name="facetName"
              :value="item"
            />
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import { computed } from 'vue'

defineEmits(['update:modelValue'])

const props = defineProps({
  facetCounts: {
    required: true,
    type: Object
  },
  facetName: {
    required: true,
    type: String
  },
  items: {
    required: true,
    type: Array
  },
  modelValue: {
    required: true,
    type: Array
  }
})

const leftItems = computed(() => {
  return props.items.slice(0, Math.ceil(props.items.length / 2))
})
const rightItems = computed(() => {
  return props.items.slice(Math.ceil(props.items.length / 2))
})
</script>
